import { AuthProvider, DataProvider } from "react-admin";
import { getTokenProvider, httpClient } from "./keycloak.http.client";
import { createDataProvider } from "../../dataprovider/dataProvider";
import AppContextProviderRegistry, {
  AppContext,
  AppContextProvider,
} from "../../app/app.context.provider";
import Keycloak, {
  KeycloakConfig,
  KeycloakInitOptions,
  KeycloakTokenParsed,
} from "keycloak-js";
import { keycloakAuthProvider } from "./keycloak.auth.provider";
import { getConfig } from "../../config/app.config";

export const KEYCLOAK_CONTEXT_KEY = "keycloak";

export class KeycloakAppContextProvider implements AppContextProvider {
  constructor() {
    AppContextProviderRegistry.registerProvider(
      KEYCLOAK_CONTEXT_KEY,
      this
    );
  }
  
  config: KeycloakConfig = {
    url: getConfig('VITE_KEYCLOAK_URL'),
    realm: getConfig('VITE_KEYCLOAK_REALM'), 
    clientId: getConfig('VITE_KEYCLOAK_CLIENT_ID'), 
  };

  initOptions: KeycloakInitOptions = { 
    onLoad: "login-required"
   };

  getPermissions = (decoded: KeycloakTokenParsed) => {
    const realmRoles = decoded?.realm_access?.roles;
    const appRoles = decoded?.resource_access?.[getConfig('VITE_KEYCLOAK_CLIENT_ID')]?.roles;
    const roles = realmRoles?.concat(appRoles);

    if (!roles) {
      return false;
    }

    if (roles.includes("Tenant.Admin")) return "Tenant.Admin";
    if (roles.includes("admin")) return "admin";
    if (roles.includes("user")) return "user";
    return false;
  };

  raKeycloakOptions = {
    onPermissions: this.getPermissions,
  };

  public async getAppContext(): Promise<AppContext> {
    try {
      const keycloakClient = new Keycloak(this.config);
      await keycloakClient.init(this.initOptions);
      const authProvider: AuthProvider = keycloakAuthProvider(
        keycloakClient,
        this.raKeycloakOptions
      );

      const idTokenProvider = getTokenProvider(keycloakClient);
      const client = httpClient(keycloakClient);
      const dataProvider = createDataProvider(client);
      const appContext: AppContext = {
        authProvider: authProvider,
        dataProvider: dataProvider,
        tokenProvider: idTokenProvider,
        httpClient: client
      };

      return appContext;
    } catch (error) {
      console.error("Error fetching auth provider:", error);
    }
  }
}
